import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { BehaviorSubject } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { MixPanelServiceTsService } from '../../services/mix-panel.service';
import { enviroment } from '../../../environments/environment';
import { AccessAccountService } from '../../services/access-account.service';
import { Companie } from '../../models/response/companie.model';
import { IntegrationService } from '../../services/integration.service';
import { PostReqOpenfinanceAgreement } from '../../models/request/post-req-openfinance-agreement';
import { Platform } from '../../models/platform.model';
import { PostReqTotalBankAgreement } from '../../models/request/post-req-total-bank-agreement';
import { PutReqTotalBankAgreement } from '../../models/request/put-req-total-bank-agreement';
import { PutReqOpenfinanceAgreement } from '../../models/request/put-req-openfinance-agreement';
import { CompanyService } from '../../services/company.service';
import { PostReqCompany } from '../../models/response/post-req-company.model';

@Component({
    selector: 'app-welcome-dialog',
    templateUrl: './welcome-dialog.component.html',
    styleUrls: ['./welcome-dialog.component.css'],
    standalone: false
})
export class WelcomeDialogComponent implements OnInit, AfterViewInit{

  @ViewChild('dialog') dialog!: Dialog;
  message!: string;
  form: FormGroup;
  totalBankForm: FormGroup;
  openFinanceForm: FormGroup;
  name!: string;
  cnpj!: string;
  visible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  maximize$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  companies: Companie[] = [];
  browserLanguage: string | null = '';
  isDisabled: boolean = true;
  successImport: boolean | null = false;
  importKey: string | null = '';
  dataSource: string | null = '';
  shownWelcomeDialog: boolean = false;
  shownConciliacao: boolean = false;
  iframeUrl: string | null = null;
  showIframe: boolean = false;
  checkShowDialog: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private translocoService: TranslocoService,
    private mixPanelService: MixPanelServiceTsService,
    private accessAccountService: AccessAccountService,
    private integrationService: IntegrationService,
    private companyService: CompanyService
  ){
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      cnpj: ['', [Validators.required, this.validateCnpj]]
    });
    this.totalBankForm = this.fb.group({
      accessAccount: ['', [Validators.required]],
      username: ['', [Validators.required]],    
      cnpj: ['', [Validators.required]]   
    });
    this.openFinanceForm = this.fb.group({
      cpf: ['', [Validators.required, this.verifyCpf()]],
      cnpj: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.shownWelcomeDialog = localStorage.getItem('shownWelcomeDialog') === 'true' ? true : false;
    this.mixPanelService.trackScreenView('Welcome Onboarding');
    if (isPlatformBrowser(this.platformId)) {
      this.checkWindowSize();
      this.browserLanguage = localStorage.getItem('browserLanguage');
      if (this.browserLanguage) {
        this.translocoService.setActiveLang(this.browserLanguage);
      }
      
      const urlParams = new URLSearchParams(window.location.search);
      const linkId = urlParams.get('linkId');
      const externalId = urlParams.get('externalId');
      
      if (linkId && externalId) {
        this.importKey = `linkId=${linkId}&externalId=${externalId}`;
        this.OpenFinanceAgreementUpdate();
      }
    }
    this.getUserCompanies();
  }

  dontShowAgain($event: any){
    const isChecked = $event.checked;

    if (isChecked) {
      localStorage.setItem('hideDialog', 'true');
    } else {
      localStorage.removeItem('hideDialog');
    }
  }

  ngAfterViewInit() {
    this.checkWindowSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkWindowSize();
  }

  getUserCompanies(){
    const accessAccountId = localStorage.getItem('accessAccount');
    if (accessAccountId) {
      this.accessAccountService.postAccessAccountCompanies(accessAccountId, { page:1, pageSize: 200 }).subscribe({
        next: (response) => {
          this.companies = [];
          this.companies = response.data.map(company => ({
            codigoEmpresa: company.id,
            razaoSocial: company.name,
            tipoDocumento: 'CNPJ',
            documento: this.formatCNPJ(company.identification)
          }));
        },
        error: (error) => {
          console.log(error);
        }
      });
    }
  }

  selectDataSource(ds: string){
    if (ds !== null) {
      this.dataSource = ds;
      if (ds == 'openFinance'){
        this.showIframe = false;
        this.navigateToStep(3);
      }else{        
        this.successImport = null;
      }
    }
  }

  importTotalBankFirstStep(){ 
    if (this.totalBankForm.valid) {
      const body: PostReqTotalBankAgreement = {
        externalUser: this.totalBankForm.get('username')?.value,
        accessAccountTotalBank: this.totalBankForm.get('accessAccount')?.value,
        platformId: Platform.getTotalBank(),
        identification: this.totalBankForm.get('cnpj')?.value
      }
      this.integrationService.postTotalBankAgreement(body).subscribe({
        next: (response) => {
          this.importKey = response.key;
          const popup = window.open(
            enviroment.URL_TOTALBANK+"login.xhtml?chaveConsentimento="+this.importKey, 
            "totalBankWindow",
            "width=1024,height=768,left=200,top=200,resizable=yes,scrollbars=yes,status=yes,location=yes,menubar=yes"
          );
          if (popup) {
            popup.focus();
          }
          this.successImport = false;
        }
      });    
    } else if (this.totalBankForm.invalid) {
      Object.keys(this.totalBankForm.controls).forEach(field => {
          const control = this.totalBankForm.get(field);
          control?.markAsTouched({ onlySelf: true });
      });
      return;
    }
  }

  checkImportTotalBank(){
    this.successImport = null;
    const body: PutReqTotalBankAgreement = {
      platformId: Platform.getTotalBank(),
      accessAccountTotalBank: this.totalBankForm.get('accessAccount')?.value,
    }
    this.integrationService.putTotalBankAgreement(body).subscribe({
      next: (response) => { 
        this.successImport = false;           
        if (response.status.order == 3){
          this.successImport = true;
        }
      },
      error: (error) => {
        this.successImport = false;
      }
    });
  }  

  applyCnpjMask(value: string): string {
    const cleaned = value.replace(/[^A-Za-z0-9]/g, '');
    return cleaned.replace(/^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})$/, '$1.$2.$3/$4-$5');
  }

  addCompany() {
    if (this.form.valid) {
      const cnpjValue = this.form.get('cnpj')?.value;
      const cnpjWithoutMask = cnpjValue.replace(/[^\d]/g, '');
      const formattedCnpj = this.applyCnpjMask(cnpjWithoutMask);
      const existingCompany = this.companies.some(
        company => company.documento === formattedCnpj
      );

      if (!existingCompany) {
        this.companies.push({
          codigoEmpresa: '',
          razaoSocial: this.form.get('name')?.value,
          tipoDocumento: 'CNPJ',
          documento: formattedCnpj
        });
      }else{
        this.message = 'companyAlreadyExists';
      }
      this.form.reset();
    } else {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  postCompanies(){
    const accessAccountId = localStorage.getItem('accessAccount');
    const groupId = localStorage.getItem('groupId') || '';
    const requester = localStorage.getItem('requester') || '';

    if (!requester) {
      console.error('Requester not found in localStorage.');
      return;
    }

    if (!accessAccountId) {
      console.error('Conta de acesso não encontrada.');
      return;
    }

    const filteredCompanies: PostReqCompany[] = [];

    this.companies.forEach(company => {
      if (!company.codigoEmpresa) {
        filteredCompanies.push({
          accessAccountId: accessAccountId,
          identificationType: 'cnpj',
          name: company.razaoSocial || '',
          email: requester,
          phone: '',
          identification: company.documento?.replace(/[^\d]/g, '') || '',
          origin: 'Total Cash',
          tradeName: company.razaoSocial || '',
          address: {
            zipCode: '',
            street: '',
            number: "0",
            complement: '',
            neighborhood: '',
            state: '',
            city: ''
          },
          groups: [{ id: groupId, name: 'Padrão' }],
          request: {
            accessAccount: accessAccountId,
            group: groupId
          }
        });
      }
    });

    console.log('Filtered Companies:', filteredCompanies);

    if (filteredCompanies.length > 0) {
      this.companyService.postCompany(filteredCompanies[0]).subscribe({
        next: (response) => {
          console.log('Company created successfully:', response);
          this.getUserCompanies();
        },
        error: (error) => {
          console.error('Error creating company:', error);
        }
      });
    } else {
      console.warn('No new companies to create.');
    }
  }

  deleteCompanie() {
    if (this.form.valid) {
      const cnpjToDelete = this.form.get('cnpj')?.value;
      const cleanedCnpjToDelete = cnpjToDelete.replace(/[^A-Za-z0-9]/g, '');
  
      this.companies = this.companies.filter(company => {
        const cleanedCompanyCnpj = company.documento?.replace(/[^A-Za-z0-9]/g, '');
        return cleanedCompanyCnpj !== cleanedCnpjToDelete;
      });
    }
  }

  checkWindowSize() {
    if (isPlatformBrowser(this.platformId)) {
      const width = window.innerWidth;
      const shouldMaximize = width <= 768;

      this.visible$.next(true);
      this.maximize$.next(shouldMaximize);
      if (this.dialog) {
        this.dialog.maximized = shouldMaximize;  
      }
      this.cdr.detectChanges();
    }
  }

  navigateToStep(step: string | number){
    if (typeof step === 'string') {
      this.mixPanelService.trackButtonClick(step);
      this.mixPanelService.trackScreenView(step);
    }else{
      this.mixPanelService.trackButtonClick('Onboarding Step ' + step);
      this.mixPanelService.trackScreenView('Onboarding step ' + step);
    }
  }

  showDialog() {
    if (isPlatformBrowser(this.platformId)) {
      this.visible$.next(true);
    }
  }

  hideDialog() {
    localStorage.setItem('shownWelcomeDialog', 'false');
    if (isPlatformBrowser(this.platformId)) {
      this.shownWelcomeDialog = false;
      this.visible$.next(false);  
    }
  }

  validateCnpj(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    const cleanValue = value.replace(/[^\d]/g, '');
    
    if (cleanValue.length !== 14) {
      return { invalidCnpj: true };
    }

    if (/^(\d)\1+$/.test(cleanValue)) {
      return { invalidCnpj: true };
    }

    let sum = 0;
    let weight = 5;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(cleanValue.charAt(i)) * weight;
      weight = weight === 2 ? 9 : weight - 1;
    }
    let digit = 11 - (sum % 11);
    if (digit > 9) digit = 0;
    if (digit !== parseInt(cleanValue.charAt(12))) {
      return { invalidCnpj: true };
    }

    sum = 0;
    weight = 6;
    for (let i = 0; i < 13; i++) {
      sum += parseInt(cleanValue.charAt(i)) * weight;
      weight = weight === 2 ? 9 : weight - 1;
    }
    digit = 11 - (sum % 11);
    if (digit > 9) digit = 0;
    if (digit !== parseInt(cleanValue.charAt(13))) {
      return { invalidCnpj: true };
    }

    return null;
  }

  private formatCNPJ(cnpj: string): string {
    if (!cnpj) return '';
    const cleanCnpj = cnpj.replace(/[^\d]/g, '');
    return cleanCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  showOpenFinanceDialog(){
    if (this.openFinanceForm.valid) {
      const userTaxId = this.openFinanceForm.get('cpf')?.value.replace(/\D/g, '');
      const businessTaxId = this.openFinanceForm.get('cnpj')?.value.documento.replace(/\D/g, '');
      
      const body: PostReqOpenfinanceAgreement = {
        platformId: Platform.getOpenFinance(),
        userTaxId: userTaxId,
        businessTaxId: businessTaxId,
      }
  
      this.integrationService.postOpenfinanceAgreement(body).subscribe({
        next: (response) => {
          if (response.interfaceURL) {
            this.iframeUrl = response.interfaceURL;
            this.showIframe = true;
          }
        }
      });
    }
  }

  OpenFinanceAgreementUpdate(){
    const body: PutReqOpenfinanceAgreement = {
      platformId: Platform.getOpenFinance(),
      linkId: this.importKey || ''
    }

    this.integrationService.putOpenfinanceAgreement(body).subscribe({
      next: (response) => {
        console.log(response);
      }
    });
  }

  verifyCpf(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      const cleanValue = value.replace(/\D/g, '');
      
      if (cleanValue.length !== 11) {
        return { cpfLengthError: 'O CPF deve ter 11 caracteres numéricos.' };
      }

      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cleanValue)) {
        return { invalidCpf: 'CPF inválido.' };
      }

      // Validação do primeiro dígito verificador
      let sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += parseInt(cleanValue.charAt(i)) * (10 - i);
      }
      let digit = 11 - (sum % 11);
      if (digit > 9) digit = 0;
      if (digit !== parseInt(cleanValue.charAt(9))) {
        return { invalidCpf: 'CPF inválido.' };
      }

      // Validação do segundo dígito verificador
      sum = 0;
      for (let i = 0; i < 10; i++) {
        sum += parseInt(cleanValue.charAt(i)) * (11 - i);
      }
      digit = 11 - (sum % 11);
      if (digit > 9) digit = 0;
      if (digit !== parseInt(cleanValue.charAt(10))) {
        return { invalidCpf: 'CPF inválido.' };
      }

      return null;
    };
  }
}